module.exports = __webpack_public_path__ + "img/smile.6fb6ec7c.svg";